// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const GridApi = t.struct({
    dateFields: t.list(t.String)
}, 'gridApi');

export const getDefaultState = () =>
    new GridApi({
        dateFields: [
            'expires',
            'terminates'
        ]
    });

export default GridApi;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/state/grid-api.js